import React from 'react';
import Responsive from '@amzn/meridian/responsive';
import { responsiveProps } from 'src/constants/responsiveProps';
import Column from '@amzn/meridian/column';
import Breadcrumb, { BreadcrumbGroup } from '@amzn/meridian/breadcrumb';
import Select, { SelectOption } from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';
import Button from '@amzn/meridian/button';
import * as AppRoutes from 'src/routing/constants/routes';
import * as AppStrings from 'src/localization/string-ids/app-strings';
import * as ErrorStrings from 'src/localization/string-ids/error-constants';
import { ScanIcons } from 'src/constants/general-media';
import { GetSortTypesOutput } from 'src/models/GetSortTypes';
import { SortContainerPages } from 'src/store/common-slices/sortContainerSlice';
import '../Sortation.scss';

interface ScanSortTypeStateProps {
    getSortTypesOutput?: GetSortTypesOutput;
    selectedSortType: string;
}

interface ScanSortTypeDispatchProps {
    setPageToRender: (pageToRender: SortContainerPages) => void;
    resetChildAndDestinationContainers: () => void;
    setSelectedSortType: (selectedSortType: string) => void;
}

type Props = ScanSortTypeStateProps & ScanSortTypeDispatchProps;

class ScanSortType extends React.Component<Props> {

    componentDidMount() {
        this.props.resetChildAndDestinationContainers();
    }

    private setSortTypeValue = (sortTypeValue: string) => {
        this.props.setSelectedSortType(sortTypeValue);
        this.props.setPageToRender(SortContainerPages.SCAN_SOURCE_CONTAINER_PAGE);
    }

    public render() {
        return(
            <Responsive query={"max-width"} props={responsiveProps}>
                {props => (
                    <div className={"sortation scan-sort-type-container"}>
                        <BreadcrumbGroup>
                            <Breadcrumb href={AppRoutes.HOME_PAGE_ROUTE}>{AppStrings.HOME}</Breadcrumb>
                            <Breadcrumb href={AppRoutes.SUB_SORT_PAGE_ROUTE}>{AppStrings.SORT}</Breadcrumb>
                        </BreadcrumbGroup>

                        <Column alignmentHorizontal={"center"}>
                            <img src={ScanIcons.SCAN_PALETTE_ICON} alt={""} className="sortation-icon"/>
                            <Text type={props.titleSize} data-testid="sort-type-heading">{AppStrings.SELECT_SORT_TYPE}</Text>
                        </Column>

                        <Select
                            value={this.props.selectedSortType}
                            onChange={this.setSortTypeValue}
                            placeholder={AppStrings.SELECT_SORT_TYPE_PLACEHOLDER}
                            size={props.isScanner ? "small" : "medium"}
                            data-testid="sort-type-select"
                        >
                            {this.props.getSortTypesOutput &&
                                this.props.getSortTypesOutput.validSortTypes.map(option => (
                                    <SelectOption label={option} value={option} key={option} />
                                ))
                            }
                            {!this.props.getSortTypesOutput &&
                                <Column
                                    alignmentVertical="center"
                                    spacingInset={props.isScanner ? "400" : "600"}
                                >
                                    <Text alignment="center">{ErrorStrings.GET_SORT_TYPES_ERROR}</Text>
                                </Column>
                            }
                        </Select>

                        <Button
                            disabled={this.props.selectedSortType === ''}
                            onClick={() => this.props.setPageToRender(SortContainerPages.SCAN_SOURCE_CONTAINER_PAGE)}
                            data-testid="sort-type-submit-button"
                        >
                            {AppStrings.SELECT_SORT_TYPE_BUTTON}
                        </Button>

                    </div>
                )}
            </Responsive>
        );
    }
}

export default ScanSortType;